import React, { useState } from 'react';
import { Modal, message } from 'antd';
import PropTypes from 'prop-types';
import { Translate, useTranslate } from '@above-the-treeline/localization';
import { useUser } from '../../../../User/containers/UserDataStore';
import {
	getInitialFormValuesById,
	getRowOptionsList,
} from './PersonalInfoModalInitializer';
import { getRowByType } from '../../Form/Form';
import { FormId } from '../../Form/FormId';

const PersonalInfoModal = ({ isVisible, setIsVisible }) => {
	const { translate } = useTranslate();
	const userDataStore = useUser();
	const { user } = userDataStore.state.user;

	const rowOptionsList = getRowOptionsList();
	const initialFormValuesById = getInitialFormValuesById(user);

	const [formValuesById, setFormValuesById] = useState(initialFormValuesById);

	const handleSave = async () => {
		if (!formValuesById['firstName'] || !formValuesById['lastName']) {
			const warningMessage = translate(
				'first_name_and_last_name_are_required',
			);
			return message.warn(warningMessage);
		}

		setIsVisible(false);

		const didSucceed = await userDataStore.saveUser(formValuesById);
		if (didSucceed) {
			return message.success(translate('personal_information_saved'));
		}
		message.error(translate('error_saving_personal_information'));
	};

	const handleCancel = () => setIsVisible(false);

	const getPersonalInfoModalRowByType = (rowOptions, i) => (
		<React.Fragment key={i}>
			{getRowByType(
				rowOptions,
				formValuesById,
				setFormValuesById,
				FormId.PersonalInfo,
			)}
		</React.Fragment>
	);

	return (
		<Modal
			visible={isVisible}
			title={
				<b>
					<Translate id="edit_personal_info" />
				</b>
			}
			onOk={handleSave}
			onCancel={handleCancel}
			okText={translate('save')}
			destroyOnClose={true}>
			<div className="personal-info-modal-contents">
				{rowOptionsList.map(getPersonalInfoModalRowByType)}
			</div>
		</Modal>
	);
};

PersonalInfoModal.propTypes = {
	isVisible: PropTypes.bool,
	setIsVisible: PropTypes.func,
	translate: PropTypes.func,
};

export default PersonalInfoModal;
